import styled from "@emotion/styled";
import { Link } from "react-router-dom";
import _ from "lodash";

import { Box, BlueText, ArrowIcon } from "components/common";
import { LDSUTabPanel } from "constant";
import { Registry } from "types/Gateways";
import styledConst from "styles";

const StyledContainer = styled.div`
    display: flex;
    padding: 17px 30px;
    align-items: center;
    gap: 17px;

    > div {
        flex: 1;
    }

    .gateway-name {
        gap: 10px;
        display: flex;
        align-items: center;

        .icon {
            width: 36px;
            height: 36px;
            border-radius: 50%;
        }
    }

    .label {
        color: ${styledConst.Primary_Blue_4};
        font-size: 14px;
        display: flex;
        align-items: center;
        gap: 5px;
    }

    a,
    .sensor-value {
        color: #00cbaf;
    }

    .action {
        display: flex;
        justify-content: space-between;
        align-items: center;

        > div {
        }

        .custom-switch {
            padding-left: 2.25rem; // Rollback to default padding of bootstrap
        }

        .label > span:first-child {
            position: relative;
            top: 2px;
        }
    }
`;

const NoteText = styled.div`
    font-size: 16px;
    color: ${styledConst.Primary_Blue_4};

    .note-label {
        color: #fff;
    }
`;

const LinkBox = ({ children, to, state }: any) => {
    return (
        <Box className="d-flex flex-fill">
            <div>{children}</div>
            <Link to={{ pathname: to, state }} className="ml-auto">
                <ArrowIcon className="material-icons align-middle">
                    keyboard_arrow_right
                </ArrowIcon>
            </Link>
        </Box>
    );
};

const LoRaWanGatewayDetail = ({
    LDSUPowerState = [],
    gateway,
}: {
    LDSUPowerState: any[];
    gateway: Registry;
}) => {
    const ldsus = _.flatten(_.map(LDSUPowerState, "info.ldsus"));
    const sensors = _.flatten(_.map(LDSUPowerState, "info.sensors"));
    const actuators = _.flatten(_.map(LDSUPowerState, "info.actuators"));

    return (
        <>
            <div>
                <StyledContainer className="form-box float-none">
                    <NoteText>
                        <span className="note-label">Note:</span>
                        <span className="ml-2">
                            Sensor/Actuator configuration with a duration
                            shorter than the report rate interval will not
                            function as expected.
                        </span>
                    </NoteText>
                </StyledContainer>
            </div>
            <div className="mt-2">
                <div className="d-flex flex-column flex-lg-row gap-2">
                    <StyledContainer className="form-box">
                        <div>
                            <div className="mb-3">Modbus</div>
                            <LinkBox
                                to={`/gateway-details/${gateway.gateway_id}/LDSBus/1`}
                                state={{
                                    gatewayName: gateway.name,
                                    panel: LDSUTabPanel.LDSU,
                                }}
                            >
                                <div>
                                    {ldsus?.length || 0}{" "}
                                    <BlueText className="ml-2 large">
                                        LDSUs
                                    </BlueText>
                                </div>
                            </LinkBox>
                        </div>
                    </StyledContainer>
                    <StyledContainer className="form-box">
                        <div>
                            <div className="mb-3">
                                Sensors and Actuators reported from connected
                                LDSUs
                            </div>
                            <div className="d-flex flex-column flex-sm-row gap-3">
                                <LinkBox
                                    to={`/gateway-details/${gateway.gateway_id}/LDSBus/1`}
                                    state={{
                                        gatewayName: gateway.name,
                                        portNumber: "1",
                                        UUID: gateway.gateway_id,
                                        panel: LDSUTabPanel.Sensor,
                                    }}
                                >
                                    <div>
                                        {sensors?.length || 0}{" "}
                                        <BlueText className="ml-2 large">
                                            Sensors
                                        </BlueText>
                                    </div>
                                </LinkBox>

                                <LinkBox
                                    to={`/gateway-details/${gateway.gateway_id}/LDSBus/1`}
                                    state={{
                                        gatewayName: gateway.name,
                                        portNumber: "1",
                                        UUID: gateway.gateway_id,
                                        panel: LDSUTabPanel.Actuator,
                                    }}
                                >
                                    <div>
                                        {actuators?.length || 0}{" "}
                                        <BlueText className="ml-2 large">
                                            Actuators
                                        </BlueText>
                                    </div>
                                </LinkBox>
                            </div>
                        </div>
                    </StyledContainer>
                </div>
            </div>
        </>
    );
};

export default LoRaWanGatewayDetail;
